export default {
  SET_GROUPS ( state, payload){
    state.groups = payload
  }
}
